export class MultiLineHeaders {
    ban: string;
    targetServiceName: any;
    requests: Requests[] = [];
}

export class IndividualLineHeaders {
    mobileNumber:any;
    //orgId: any;
    ban: any;
    reasonCode: any;
    suspendStartDate: any;
    restoreDate: any;
    extendContract: any;
    logonId: any;
    email: any;
    dealerCode: any;
    validatorType: any;
}

export class Requests {
    orgId: any;
    ban: any;
    reasonCode: any;
    suspendStartDate: any;
    restoreDate: any;
    extendContract: any;
    logonId: any;
    email: any;
    dealerCode: any;
    validatorType: any;
    msisdn: any;
}

export class MultiLineBulkSwapHeaders {
    ban: string;
    targetServiceName: any;
    requests: RequestsBulkSwap[] = [];
}

export class RequestsBulkSwap {
    orgId: any;
    logonId: any;
    email: any;
    newSim: any;
    reasonCode: any;
    msisdn: any;
    eid:any;
}

export class MultiLineBulkPortinHeaders {
    targetServiceName: string;
    ban: string;
    requests: RequestsBulkPortin[] = [];
}

export class RequestsBulkPortin {
    logonId?: any;
    orgId: string;
    email?: any;
    billingAccountNumber: string;
    portInDateTime: string;
    msisdn: string;
    newMsisdn: string;
    reasonCode: string;
    ospAccountPassword?: string;
    ospAccount: string;    
}

export class IndividualSimChangeRes {
    logonId: any;
    email: any;
    newSim: any;
    oldSim: any;
    reasonCode: any;
    ban: any;
    mobileNumber?: string;
    ospAccountPassword?: string;  
    ospAccount: string;
    eid:any;

}

export class RequestsForRestore {   
    mobileNumber:any;
    orgId: string;
    ban: string;
    reasonCode: string;
    restoreDate: string;
    logonId: string;
    email: string;
    dealerCode: string;
}

export class BulkRequestsForRestore {
    targetServiceName: string;
    ban: string;
    requests: RequestsBulkLine[] = [];
}

export class RequestsBulkLine {
    orgId: any;
    msisdn: any;
    reasonCode: any;
    restoreDate: any;
    logonId: any;
    email: any;
    dealerCode: any;
    validatorType: any;
}

export class ColumnDefinition {
    headerName: string;
    dataType: string;
    range?: any;
    length?: number;
    minDate?: Date;
    maxDate?: Date;
}
export class SingleLineIdentifier {
    oldUDFID1: string;

    oldUDFID2: string;

    oldUDFID3: string;

    uDFID1: string;

    uDFID2: string;

    uDFID3: string;
    msisdn: string;

    logonID?: string;
    email?: string;
    userId?: string;
    orgId?: string;

}
export class dModelTransferNumber {
    billingAccountNumber: string;
    portInDateTime: string;
    mobileNumber?: string;
    msisdn?: string;
    newMsisdn: string;
    reasonCode: string;
    ospAccountPassword?: string;    
    ospAccount: string;
    logonId?: any;
    email?: any;
        
}

export class portInEligibilityRequest {
    billingAccountNumber: string;
    type: string;
    msisdns: portInMsisdnReq[] = [];        
}
export class portInMsisdnReq {
    oldMsisdn: string;     
    portInDateTime: string;
    portInNumber: string;
    ospAccountNumber: string;        
}

export class bulkRequestForTransferNumber{
    targetServiceName: string;
    ban: string;
    requestpayload: dModelTransferNumber[] = [];
}

export class RequestsLineIdentifier {
    orgId?: any;
    billingAccount?: any;
}

export class RequestForLineidentifier {
  msisdn: string;
  ban: string;
  udf1: string
  udf2: string;
  udf3: string;
  udf4: string;
  udf5: string;
  udf6: string;
}

export class BulkRequestsForLineIdentifier{
    targetServiceName: string;
    ban: string;
    requests: RequestsBulkLineIdentifier[] = [];
}
    
export class RequestsBulkLineIdentifier {
    orgId: string;
    logonId: string;
    email: string;
    msisdn: string;
    userId: string;
    ban: string;
    uDFID1: string;
    uDFID2: string;
    uDFID3: string;
    uDFID4: string;
    uDFID5: string;
    uDFID6: string;
}
export class RateplanDetails {
    planName: string;
    planStatus: string;
    changeEffectiveDate: string;
    mrc: string;
    amountDue: any;
    subLineType: string;

}
